<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{companyId ? 'Update' : 'Add New'}} Table Data</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="tableDataForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Company Name</mat-label>
              <input matInput placeholder="Company Name" formControlName="companyName">
              <mat-error *ngIf="tableDataForm.controls['companyName'].touched && tableDataForm.controls['companyName'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>BBB Review</mat-label>
              <input type="number" matInput placeholder="BBB Review" formControlName="bbbReview" min="0" max="5">
              <mat-error *ngIf="tableDataForm.controls['bbbReview'].touched && tableDataForm.controls['bbbReview'].hasError('required')">
                This is a required field.</mat-error>
                <mat-error *ngIf="tableDataForm.controls['bbbReview'].touched && tableDataForm.controls['bbbReview'].hasError('min')">
                 Minimum value should be 0.</mat-error>
                  <mat-error *ngIf="tableDataForm.controls['bbbReview'].touched && tableDataForm.controls['bbbReview'].hasError('max')">
                      Maximum value should be 5</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>BBB Accredited</mat-label>
              <mat-select formControlName="bbbAccredited">
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
              <mat-error *ngIf="tableDataForm.controls['bbbAccredited'].touched && tableDataForm.controls['bbbAccredited'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>BBB Rating</mat-label>
              <input #bbbRating matInput placeholder="BBB Rating" formControlName="bbbRating" (input)="bbbRating.value = bbbRating.value.toUpperCase()">
              <mat-error *ngIf="tableDataForm.controls['bbbRating'].touched && tableDataForm.controls['bbbRating'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>BBB Complaints</mat-label>
              <input type="text" matInput placeholder="BBB Complaints" formControlName="bbbComplaints" (keypress)="numberCommaPlusOnly($event)">
              <mat-error *ngIf="tableDataForm.controls['bbbComplaints'].touched && tableDataForm.controls['bbbComplaints'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Copayment</mat-label>
              <input matInput placeholder="Copayment" formControlName="copayment">
              <mat-error *ngIf="tableDataForm.controls['copayment'].touched && tableDataForm.controls['copayment'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Work Guarantee</mat-label>
              <input matInput placeholder="Work Guarantee" formControlName="workGuarantee">
              <mat-error *ngIf="tableDataForm.controls['workGuarantee'].touched && tableDataForm.controls['workGuarantee'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Coverage</mat-label>
              <mat-select formControlName="coverage">
                <mat-option value="Just Parts">Just Parts</mat-option>
                <mat-option value="Just Labor">Just Labor</mat-option>
                <mat-option value="Parts and Labor">Parts and Labor</mat-option>
                <mat-option value="Parts, Labor and Installation">Parts, Labor and Installation</mat-option>
              </mat-select>
              <mat-error *ngIf="tableDataForm.controls['coverage'].touched && tableDataForm.controls['coverage'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Appliances Payout</mat-label>
              <input matInput placeholder="Appliances Payout" formControlName="applianceCaps">
              <mat-error *ngIf="tableDataForm.controls['applianceCaps'].touched && tableDataForm.controls['applianceCaps'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Systems Payout</mat-label>
              <input matInput placeholder="Systems Payout" formControlName="systemsCaps">
              <mat-error *ngIf="tableDataForm.controls['systemsCaps'].touched && tableDataForm.controls['systemsCaps'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Maintenance Record</mat-label>
              <mat-select formControlName="maintenanceRecord">
                <mat-option [value]="true">Required</mat-option>
                <mat-option [value]="false">Not Required</mat-option>
              </mat-select>
              <mat-error *ngIf="tableDataForm.controls['maintenanceRecord'].touched && tableDataForm.controls['maintenanceRecord'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Starting Price</mat-label>
              <input matInput placeholder="Starting Price" formControlName="startingPrice">
              <mat-error *ngIf="tableDataForm.controls['startingPrice'].touched && tableDataForm.controls['startingPrice'].hasError('required')">
                  This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Redirect Url</mat-label>
              <input matInput placeholder="Redirect Url" formControlName="redirectUrl">
              <mat-error *ngIf="tableDataForm.controls['redirectUrl'].touched && tableDataForm.controls['redirectUrl'].hasError('required')">
                  This is a required field.</mat-error>
                  <mat-error
                  *ngIf="tableDataForm.controls['redirectUrl'].touched && tableDataForm.controls['redirectUrl'].hasError('pattern')">
                  Please enter valid url.</mat-error>
            </mat-form-field>
          </div>


          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="addEditTableData()"><span>{{companyId ? 'Update' : 'Add'}}</span></button>
            <button mat-button type="button" class="can-button" (click)="this.location.back()"><span>Cancel</span></button>
          </div>
            
           
          </form>
    </div>
  </div>

